/**
 * Protocol Status Badge Component
 */

import type { ProtocolStatus } from '../../types';

interface ProtocolStatusBadgeProps {
  status: ProtocolStatus;
  size?: 'sm' | 'md';
}

const STATUS_CONFIG: Record<
  ProtocolStatus,
  { label: string; bgColor: string; textColor: string; dotColor: string }
> = {
  setup: {
    label: 'Setup',
    bgColor: 'bg-amber-50 dark:bg-amber-900/20',
    textColor: 'text-amber-700 dark:text-amber-300',
    dotColor: 'bg-amber-500',
  },
  active: {
    label: 'Active',
    bgColor: 'bg-green-50 dark:bg-green-900/20',
    textColor: 'text-green-700 dark:text-green-300',
    dotColor: 'bg-green-500',
  },
  paused: {
    label: 'Paused',
    bgColor: 'bg-gray-50 dark:bg-gray-900/40',
    textColor: 'text-gray-700 dark:text-gray-300',
    dotColor: 'bg-gray-500',
  },
  closed: {
    label: 'Closed',
    bgColor: 'bg-red-50 dark:bg-red-900/20',
    textColor: 'text-red-700 dark:text-red-300',
    dotColor: 'bg-red-500',
  },
};

export function ProtocolStatusBadge({ status, size = 'sm' }: ProtocolStatusBadgeProps) {
  const config = STATUS_CONFIG[status];

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full ${config.bgColor} ${config.textColor} ${
        size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm'
      }`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${config.dotColor}`} />
      {config.label}
    </span>
  );
}
